import styled from 'styled-components'

export default styled.section`
  background-color: ${ ({ theme }) => theme.colors.primary };
  min-height: 80px;
  flex: 0;
  width: 100%;
  max-width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 60px;
  box-sizing: border-box;
  
  .logo {
    flex: 1;
    img {
      height: 24px;
      width: auto;
      position: relative;
      top: 2px;
      padding-right: 10px;
    }
    &.nemi,
    &.iframe {
      img {
        height: 80px;
      }
    }
    &.beirabaixa {
      img {
        height: 48px;
        top: 0;
      }
    }
    .mobile {
      display: none;
    }
  }

  .menu-burger {
    display: none;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
      filter: invert(1);
    }

    label {
      padding: 0 20px;
      font-size: 20px;
      text-transform: uppercase;
      font-weight: bold;
      color: ${ ({ theme }) => theme.colors.white };
    }
  }

  > .navigation {
    flex-basis: 800px;
    height: 100%;
    min-height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    a {
      padding: 0 20px;
      font-size: 18px;
      text-transform: uppercase;
      font-weight: bold;
      line-height: initial !important;
      color: ${ ({ theme }) => theme.colors.white };
      text-decoration: none;
      border: 3px solid transparent;
      box-sizing: border-box;
      height: 100%;
      min-height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      transition: ease all 0.1s;

      &.active {
        border-bottom-color: ${ ({ theme }) => theme.colors.white };
        background-color: ${ ({ theme }) => theme.colors.white }4D;
      }

      &:hover {
        background-color: ${ ({ theme }) => theme.colors.white }33;
      }
    }
  }

  .account {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      p {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        color: ${ ({ theme }) => theme.colors.white };
        font-family: ${ ({ theme }) => theme.fontFamily };
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 20px;
        margin: 0 !important;

        img {
          width: 44px;
          height: 44px;
          margin-right: 12px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0 10px;
    display: flex;
    flex-direction: row;

    .logo {
      display: none !important;
    }

    .menu-burger {
      display: flex;
      align-items: center;
    }

    .navigation {
      display: none;

      &.mobile.open {
        width: 100%;
        position: absolute;
        top: 80px;
        left: 0;
        display: flex;
        flex-direction: column;
        /* In a column the desktop centring would push the links to the middle of the screen. */
        justify-content: flex-start;
        background-color: ${ ({ theme }) => theme.colors.primary };
        z-index: 99;

        a {
          height: 20px;
          width: 100%;
        }
      }
    }

    .account {
      .username img {
        width: 40px;
        height: 40px;
        margin-right: 0px;
      }

      p span {
        display: none;
      }
    }
  }
`
